import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptLoiret45 = () => {
  return (
    <DepartmentTemplate
      department="Loiret"
      departmentNumber="45"
      cities="Orléans, Montargis, Gien, Pithiviers"
      region="Centre-Val de Loire"
    />
  );
};

export default DeptLoiret45;
